import { mapState } from "pinia";
import { defineComponent } from "vue";

import WidgetIndicator from '~/components/widget-indicator/widget-indicator.vue';
import ComponentBase from "~/components/component-base";
import { useDashboardStore } from "~/store/dashboard.store";
import { useStationStore } from "~/store/station.store";

export default defineComponent({
    
    extends: ComponentBase,

    components: {
        WidgetIndicator,
    },

    computed: {
        ...mapState(useDashboardStore, ['indicators']),
        ...mapState(useStationStore, ['stations']),

        count(): number {
            return this.indicators?.ok?.value;
        },

        variation(): number { 
            return this.indicators?.ok?.variation;
        },

        color(): string {
            if(this.variation > 0) {
              return 'has-text-success';
            } else if (this.variation < 0) {
              return 'has-text-danger';
            } else {
              return '';
            }
        }
    }
});